<template>
    <div>
      <v-text-field label="Suche" variant="filled" v-model="fulltextSearch" append-inner-icon="mdi-magnify" @click:append-inner="doSearch"
        @keypress.enter="doSearch" hide-details :loading="store.loading" />
      <v-container v-if="!store.loading && store.displayFilters.length > 0" fluid>
        <filter-list :store="store" />
      </v-container>
      <div v-if="!store.loading && !store.error">
        <v-list lines="two">

          <template v-for="contactHistory in store.data" :key="`${contactHistory.Nr}-${contactHistory.KundeName}`">
            <v-list-item link :to="{
              name: 'contact_histories_details',
              params: {
                id: contactHistory.KundenNr,
                contact_history_id: contactHistory.Nr,
                name: kundenName,
              },
            }">
              <template #prepend>
                <v-icon :color="contactHistory.typeColor">{{ contactHistory.typeIcon }}</v-icon>
              </template>

                <v-list-item-title :class="{'font-weight-black': !contactHistory.read}">{{ contactHistory.Thema }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ contactHistory.WiedervorlageDatumFormatted }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>{{ contactHistory.KundeName }}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="contactHistory.Ansprechpartner.length > 0">{{
                  contactHistory.AnsprechpartnerFormatted
                }}</v-list-item-subtitle>

              <template #append>
                <v-list-item-action>
                  <v-icon :color="contactHistory.readColor">{{ contactHistory.readIcon }}</v-icon>
                </v-list-item-action>
              </template>
            </v-list-item>
            <hr
              role="separator"
              aria-orientation="horizontal"
              class="v-divider"
              theme="light"
            />
          </template>

        </v-list>
        <v-container fluid class="mb-10">
          <pagination :module="store.$id" />
        </v-container>
      </div>
      <template v-else-if="store.error">
        <error :module="store.$id" />
      </template>
    </div>
  </template>

<script lang="ts" setup>
import FilterList from '@/components/FilterList.vue';
import Pagination from '@/components/Pagination.vue';
import Error from '@/components/Error.vue';
import {computed, ref, watch} from 'vue';
import {useStorage} from '@/composables/storage';
import {useRoute} from 'vue-router';
import {useFilterSort} from '@/composables/filterSort';
import useFollowupsStore from '@/store/followups';

const route = useRoute();
const emit = defineEmits({'close': () => true});
const store = useFollowupsStore();
const {filters, save} = useFilterSort(store, emit);
useStorage(
    store,
    (items, route) => route?.params.name ? `Wiedervorlagen mit ${route?.params.name}` : 'Wiedervorlage',
    (route, _originalFilters, defaultFilters) => {
      return defaultFilters;
    },
);
const fulltextSearch = computed({
  get(): string {
    return filters.value.Fulltext$Fulltext.words.join(' ');
  },
  set(val: string) {
    if (!val) {
      filters.value.Fulltext$Fulltext.words = [];
      return;
    }
    filters.value.Fulltext$Fulltext.words = val.split(' ');
  },
});

function doSearch() {
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);
  save();
};

const searchDebounceTimeout = ref<NodeJS.Timeout | null>(null);
const kundenName = ref('');
kundenName.value = Array.isArray(route.params.name) ? route.params.name[0] : route.params.name; // onCreated()

watch(fulltextSearch, (newVal: string, oldVal: string) => {
  if (newVal === oldVal || newVal.length < 3) return;
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);

  searchDebounceTimeout.value = setTimeout(() => {
    doSearch();
  }, 500);
});

defineExpose({
  route,
  emit,
  filters, save,
  store,
  fulltextSearch,
  doSearch,
  searchDebounceTimeout,
  kundenName,
  Error,
  Pagination,
  FilterList,
});
</script>

